export const WISH_MODULE = {
  IT: {
    ListUrl: 'itList',
    CreateUrl: 'itCreate',
    UpdateUrl: 'itUpdate',
    DeleteUrl: 'itDelete',
    GetUrl: 'itGet',
    tableHead: [
      { label: '心愿单编号', prop: 'code', slotName: 'code', slotColumn: true },
      { label: '模块', prop: 'moduleName', width: 100  },
      { label: '类别', prop: 'categoryName' },
      { label: '产品/服务名称', prop: 'productName' },
      { label: '是否定制开发', prop: 'izCustomizedName' },
      { label: '数量', prop: 'quantity' },
      { label: '联系人', prop: 'contacts' },
      { label: '需求部门', prop: 'demandDepartment' },
      { label: '备注', prop: 'remark' },
      { label: '创建人', prop: 'createByName' },
      { label: '创建时间', prop: 'createDate' }
    ]
  },
  MATERIEL: {
    ListUrl: 'materielList',
    CreateUrl: 'materielCreate',
    UpdateUrl: 'materielUpdate',
    DeleteUrl: 'materielDelete',
    GetUrl: 'materielGet',
    tableHead: [
      { label: '心愿单编号', prop: 'code', slotName: 'code', slotColumn: true, width: 150 },
      { label: '模块', prop: 'moduleName', width: 100 },
      { label: '产品名称', prop: 'productName' },
      { label: '材质', prop: 'material' },
      { label: '工艺', prop: 'technology' },
      { label: '参考方向', prop: 'referenceDirection' },
      { label: '是否定制', prop: 'izCustomizedName' },
      { label: '需求数量', prop: 'quantity' },
      { label: '期望交付时间', prop: 'expectedDeliveryDate' },
      { label: '联系人', prop: 'contacts' },
      { label: '需求部门', prop: 'demandDepartment' },
      { label: '备注', prop: 'remark' },
      { label: '创建人', prop: 'createByName' },
      { label: '创建时间', prop: 'createDate' }
    ]
  },
  PROFESSIONAL_SERVICE: {
    ListUrl: 'professionalServiceList',
    CreateUrl: 'professionalServiceCreate',
    UpdateUrl: 'professionalServiceUpdate',
    DeleteUrl: 'professionalServiceDelete',
    GetUrl: 'professionalServiceGet',
    tableHead: [
      { label: '心愿单编号', prop: 'code', slotName: 'code', slotColumn: true },
      { label: '模块', prop: 'moduleName', width: 100 },
      { label: '服务类别', prop: 'categoryName' },
      { label: '服务名称', prop: 'productName' },
      { label: '服务地点', prop: 'serviceLocation' },
      { label: '需求数量', prop: 'quantity' },
      { label: '联系人', prop: 'contacts' },
      { label: '需求部门', prop: 'demandDepartment' },
      { label: '备注', prop: 'remark' },
      { label: '创建人', prop: 'createByName' },
      { label: '创建时间', prop: 'createDate' }
    ]
  }
}